var getSingleResourceDescription = function getSingleResourceDescription(param) {
    var hasProjectState = param.hasProjectState, isProjectsError = param.isProjectsError;
    if (hasProjectState) {
        if (isProjectsError) {
            return 'DeleteSingleResourcePrompt.description.projectSpecific.error';
        }
        return 'DeleteSingleResourcePrompt.description.projectSpecific';
    }
    return 'DeleteSingleResourcePrompt.description.default';
};
export var DeleteSingleResourcePromptHelpers = {
    getSingleResourceDescription: getSingleResourceDescription
};

//# sourceMappingURL=DeleteSingleResourcePromptHelpers.js.map